import * as React from "react";
import { SORT_SVG } from "../../IconConsts";
import CheckboxDataInput from "../checkboxDataInput/CheckboxDataInput";

export interface ITableHeaderSectionProps {
    section: string | React.ReactNode;
    fieldName: string;
    isSortingActive: boolean;
    ascending: boolean;
    onClickHeaderSection: (section: string, ascending:boolean) => void;
    sortable?: boolean;
    checkable?: boolean;
    isChecked?: boolean;
    onCheckboxChange?: (section: string, checked: boolean) => void;
}

interface ITableHeaderSectionState { }

export default class TableHeaderSection extends React.PureComponent<
    ITableHeaderSectionProps,
    ITableHeaderSectionState
> {
    checked: boolean;
    sorting: boolean;
    

    onClick = () => {
        const { onClickHeaderSection, fieldName } = this.props;
        this.sorting = !this.sorting;
        onClickHeaderSection(fieldName, this.sorting);
    };

    onCheck = () => {
        const { onCheckboxChange, fieldName } = this.props;
        this.checked = !this.checked;
        onCheckboxChange(fieldName, this.checked);
    };

    renderSortingIcons = () => {
        const { sortable, section } = this.props;

        
        const isEmptySection =
            section === null ||
            section === undefined ||
            (typeof section === "string" && section.trim() === "");

        if (sortable) {
            if (isEmptySection) {
                return <div className="sortIcon" />;
            }

            return (
                <img
                    src={SORT_SVG}
                    title="Sort"
                    alt="Sort Icon"
                    className="sortIcon"
                />
            );
        }

        return <div className="sortIcon" />;
    };

    renderCheckbox = () => {
        const { isChecked, onCheckboxChange, fieldName } = this.props;
        return (
            <CheckboxDataInput
                key={`${fieldName}Checkbox`}
                label=""
                inline={false}
                fieldName={fieldName}
                value={isChecked}
                changeData={(value) => onCheckboxChange(fieldName, value as boolean)}
                readonly={false}
                isHidden={false}
            />
        );
    };

    render() {
        const { section, sortable, checkable } = this.props;

        return (
            <div
                className={["headerCell", sortable && "headerCellSortable"].join(" ")}
                onClick={sortable ? () => this.onClick() : null}
                id={`usage-maintenance-details-grid-header-section ${section}`}
            >
                <div style={{ display: "flex" }}>
                    {section}
                    {sortable && this.renderSortingIcons()}
                </div>
                {checkable && (
                    <div className="headerCellWithCheckbox">
                        {this.renderCheckbox()}
                    </div>
                )}
            </div>
        );
    }
};